<template>
  <Transition name="snackbar">
    <div
      v-if="snackbar.visible"
      class="snackbar-container"
      :class="[`snackbar--${snackbar.type}`]"
      role="alert"
      aria-live="polite"
    >
      <div class="snackbar-body">
        <i :class="iconClass"></i>
        <span class="snackbar-message">{{ snackbar.message }}</span>
        <button type="button" class="snackbar-close" aria-label="Close" @click="snackbar.dismiss()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue'
import { useSnackbarStore } from '@/stores/snackbar'

const snackbar = useSnackbarStore()

const iconClass = computed(() => {
  const icons = {
    success: 'bi bi-check-circle-fill',
    error: 'bi bi-exclamation-circle-fill',
    warning: 'bi bi-exclamation-triangle-fill',
    info: 'bi bi-info-circle-fill'
  }
  return icons[snackbar.type] || icons.info
})
</script>

<style scoped>
.snackbar-container {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 9999;
  min-width: 320px;
  max-width: 520px;
  width: auto;
  pointer-events: auto;
}

.snackbar-body {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
}

.snackbar--success .snackbar-body {
  background: #16a34a;
}

.snackbar--error .snackbar-body {
  background: #dc2626;
}

.snackbar--warning .snackbar-body {
  background: #d97706;
}

.snackbar--info .snackbar-body {
  background: #333;
}

.snackbar-message {
  flex: 1;
  line-height: 1.4;
}

.snackbar-close {
  border: 0;
  background: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.snackbar-close:hover {
  color: #fff;
}

/* ─── Transition ─────────────────────────────────────────── */
.snackbar-enter-active {
  animation: snackbar-in 0.3s ease;
}

.snackbar-leave-active {
  animation: snackbar-out 0.25s ease forwards;
}

@keyframes snackbar-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes snackbar-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

@media (max-width: 576px) {
  .snackbar-container {
    min-width: unset;
    width: calc(100% - 32px);
    left: 16px;
    right: 16px;
  }
}
</style>
